import React from 'react';
import clsx from 'clsx';

/**
 * Skeleton — content placeholder while loading.
 *
 * <Skeleton className="h-4 w-32" />
 * <Skeleton.Text lines={3} />
 * <Skeleton.Card />
 * <Skeleton.Avatar />
 */
export function Skeleton({ className, rounded = 'md' }) {
    const radius = {
        none: 'rounded-none',
        sm:   'rounded-md',
        md:   'rounded-md',
        lg:   'rounded-lg',
        pill: 'rounded-pill',
    }[rounded] || 'rounded-md';

    return (
        <span
            aria-hidden="true"
            className={clsx(
                'block bg-surface-sunken animate-pulse-soft',
                radius,
                className,
            )}
        />
    );
}

Skeleton.Text = function SkeletonText({ lines = 3, className }) {
    return (
        <div className={clsx('space-y-2', className)} role="status" aria-label="טוען תוכן">
            {Array.from({ length: lines }).map((_, i) => (
                <Skeleton
                    key={i}
                    className={clsx('h-3', i === lines - 1 ? 'w-2/3' : 'w-full')}
                />
            ))}
        </div>
    );
};

Skeleton.Avatar = function SkeletonAvatar({ size = 'md', className }) {
    const sz = { sm: 'w-8 h-8', md: 'w-10 h-10', lg: 'w-14 h-14', xl: 'w-20 h-20' }[size] || 'w-10 h-10';
    return <Skeleton rounded="pill" className={clsx(sz, className)} />;
};

Skeleton.Card = function SkeletonCard({ className }) {
    return (
        <div className={clsx('surface-card p-5 space-y-4', className)} role="status" aria-label="טוען...">
            <div className="flex items-center gap-3">
                <Skeleton.Avatar />
                <div className="flex-1 space-y-2">
                    <Skeleton className="h-3 w-1/3" />
                    <Skeleton className="h-2.5 w-1/4" />
                </div>
            </div>
            <Skeleton.Text lines={3} />
            <div className="flex gap-2">
                <Skeleton className="h-8 w-20" rounded="lg" />
                <Skeleton className="h-8 w-20" rounded="lg" />
            </div>
        </div>
    );
};

export default Skeleton;
